module.exports = __webpack_public_path__ + "img/mixer_img.ca406e09.png";